import { Asset, EnvLighting } from 'playcanvas';


const load = (app, url, callback) => {
    const asset = new Asset(
        'cubemap',
        'texture',
        { url: url },
        { mipmaps: false }
    );

    asset.once('load', () => {
        const skybox = EnvLighting.generateSkyboxCubemap(asset.resource);
        const lighting = EnvLighting.generateLightingSource(asset.resource);
        const prefiltered = EnvLighting.generateAtlas(lighting);
        lighting.destroy();

        callback(asset, skybox, prefiltered);
    });

    app.assets.add(asset);
    app.assets.load(asset);
};

export default load;